<div class="dialog-content" style="display: flex; width: 100%">
  <div style="width: 65%">
    <app-patient-view-component
      *ngIf="patient"
      isAuditing="true"
      [loadingAuditPatient]="loadingAuditPatient"
      [isPatientDataValidated]="data.appointment.IsPatientDataValidated"
      (auditChange)="onPatientAuditChange($event)"
      [patientview]="patient"
    ></app-patient-view-component>

    <mat-spinner [diameter]="50" *ngIf="loadingPatient"></mat-spinner>

    <div class="card-inline">
      <h4>Orden</h4>
      <div class="spacer"></div>
    </div>
    <div>
      <mat-spinner [diameter]="50" *ngIf="!orderAuditing"></mat-spinner>
      <app-medical-appointment-order-auditing
        *ngIf="orderAuditing"
        (dataChange)="orderChanged($event)"
        [data]="orderAuditing"
      >
      </app-medical-appointment-order-auditing>
    </div>

    <mat-divider></mat-divider>
    <div class="card-inline">
      <h4>Prácticas</h4>
      <div class="spacer"></div>
      <button
        (click)="auditProcedures()"
        [disabled]="loadingAuditProcedure"
        mat-flat-button
        color="primary"
        type="button"
        style="margin-left: 5px; margin-bottom: 5px"
      >
        {{
          data.appointment.IsProcedureValidated
            ? "Revertir controlado"
            : "Controlado"
        }}
      </button>
    </div>

    <div *ngIf="!laodingValorization" class="card-inline">
      <app-medical-appointment-plan-auditing
        [plan]="planId"
        [entity]="entityId"
        (planChange)="planChanged($event)"
      ></app-medical-appointment-plan-auditing>
    </div>

    <mat-spinner [diameter]="50" *ngIf="laodingValorization"></mat-spinner>
    <table
      *ngIf="!laodingValorization"
      mat-table
      [dataSource]="valorizationItems"
    >
      <ng-container matColumnDef="practiceName">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>Nombre</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          {{ getName(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell class="table-header" *matHeaderCellDef>Cantidad</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayQuantity(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="feeAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>$Hon</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayFeeAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="feeCoverage">
        <th mat-header-cell class="table-header" *matHeaderCellDef>%Hon</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayFeeCoverage(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="rightsAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>$Der</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayRightsAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="rightsCoverage">
        <th mat-header-cell class="table-header" *matHeaderCellDef>%Der</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayRightsCoverage(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="moduleAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>$Mod</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayModuleAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="moduleCoverage">
        <th mat-header-cell class="table-header" *matHeaderCellDef>%Mod</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayModuleCoverage(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="supplieAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>$Ins</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displaySupplieAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="supplieCoverage">
        <th
          mat-header-cell
          class="search-table-header resizable-column"
          *matHeaderCellDef
        >
          <resizable-column-control
            width="50"
            tile="%Ins"
          ></resizable-column-control>
        </th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displaySupplieCoverage(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="assuranceAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>Coseguro</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayAssuranceAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="totalAmount">
        <th mat-header-cell class="table-header" *matHeaderCellDef>Total</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayTotalAmount(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="patientAmountWithTax">
        <th mat-header-cell class="table-header" *matHeaderCellDef>
          Total Pac c/iva
        </th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayPatientAmountWithTax(element) }}</div>
        </td>
      </ng-container>

      <ng-container *ngIf="seeAmounts" matColumnDef="entityAmountWithTax">
        <th mat-header-cell class="table-header" *matHeaderCellDef>
          Total Os c/iva
        </th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>{{ displayEntityAmountWithTax(element) }}</div>
        </td>
      </ng-container>

      <tr
        class="val-cell"
        mat-header-row
        *matHeaderRowDef="
          seeAmounts
            ? displayAllValorizationItemsColumns
            : displayNoAmountValorizationItemsColumns
        "
      ></tr>
      <tr
        class="val-cell"
        mat-row
        *matRowDef="
          let row;
          columns: seeAmounts
            ? displayAllValorizationItemsColumns
            : displayNoAmountValorizationItemsColumns
        "
      ></tr>
    </table>

    <div class="card-inline">
      <h4>Documentación</h4>
      <div class="spacer"></div>
      <button
        (click)="auditDocumentation()"
        [disabled]="loadingAuditDocumentation"
        mat-flat-button
        color="primary"
        type="button"
        style="margin-left: 5px; margin-bottom: 5px"
      >
        {{
          data.appointment.IsDocumentationValidated
            ? "Revertir controlado"
            : "Controlado"
        }}
      </button>
    </div>

    <mat-spinner [diameter]="50" *ngIf="laodingValorization"></mat-spinner>
    <table
      *ngIf="!laodingValorization"
      mat-table
      [dataSource]="documentationItems"
    >
      <ng-container matColumnDef="name">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>Nombre</th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          <div>
            <b>{{ displayDocumentName(element) }}</b>
            <p>{{ displayDocumentDescription(element) }}</p>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="carryPatient">
        <th class="val-cell" mat-header-cell *matHeaderCellDef>
          Trajo paciente
        </th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          {{ displayDocumentCarryPatient(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="info">
        <th class="val-cell" mat-header-cell *matHeaderCellDef></th>
        <td class="val-cell" mat-cell *matCellDef="let element">
          {{ displayDocumentInfo(element) }}
        </td>
      </ng-container>

      <!-- Star Column -->
      <ng-container matColumnDef="star" stickyEnd>
        <th
          class="val-cell"
          style="width: 1px"
          mat-header-cell
          *matHeaderCellDef
        ></th>
        <td
          class="val-cell"
          style="width: 1px"
          mat-cell
          *matCellDef="let element"
        ></td>
      </ng-container>
      <tr
        class="val-cell"
        mat-header-row
        *matHeaderRowDef="displayDocumentationItemsColumns; sticky: true"
      ></tr>
      <tr
        class="val-cell"
        mat-row
        *matRowDef="let row; columns: displayDocumentationItemsColumns"
      ></tr>
    </table>

    <mat-divider></mat-divider>

    <div class="card-inline">
      <h4>HCE</h4>
      <div class="spacer"></div>
      <button
        (click)="auditMedicalRecordValidated()"
        [disabled]="loadingAuditMedicalRecord"
        mat-flat-button
        color="primary"
        type="button"
        style="margin-left: 5px; margin-bottom: 5px"
      >
        {{
          data.appointment.IsMedicalRecordValidated
            ? "Revertir controlado"
            : "Controlado"
        }}
      </button>
    </div>

    <mat-divider></mat-divider>

    <div class="card-inline">
      <h4>Call Center</h4>
      <div class="spacer"></div>
      <button
        (click)="auditReferredToCallCenterValidated()"
        [disabled]="loadingReferredToCallCenter"
        mat-flat-button
        color="primary"
        type="button"
        style="margin-left: 5px; margin-bottom: 5px"
      >
        {{
          data.appointment.IsReferredToCallCenter
            ? "Revertir derivación"
            : "Derivar"
        }}
      </button>
    </div>
  </div>

  <div style="width: 35%; padding: 5px">
    <button mat-button (click)="openLogViewDialog()">
      <mat-icon>search</mat-icon><span>Ver actividades</span>
    </button>

    <button mat-button (click)="openMedicalAppointmentObservationDialog()">
      <mat-icon>search</mat-icon><span>Ver observaciones</span>
    </button>

    <medical-order-scann-control
      [readOnly]="true"
      [medicalorderId]="orderId"
    ></medical-order-scann-control>
  </div>
</div>

<div *ngIf="existOtherAppointments" class="dialog-actions">
  <div class="pull-right">
    <div style="padding: 5px">
      <button mat-flat-button type="button" (click)="auditOther()">
        El paciente tiene turnos para el mismo día ¿Desea controlarlos?
      </button>
    </div>
  </div>
</div>
<div class="dialog-actions">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Salir
    </button>

    <button mat-button type="button" cdkFocusInitial (click)="saveAndClose()">
      Guardar y salir
    </button>

    <button
      *ngIf="canReservationReschedule"
      mat-button
      type="button"
      cdkFocusInitial
      (click)="reservationRescheduling()"
    >
      Reprogramar
    </button>
  </div>
</div>
